import React from "react";

interface IconProps {
  active?: boolean;
  color?: string; // Optional parameter for color (default: #004B8B)
}

export const DashBoardIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 9C10.7909 9 9 10.7909 9 13V22.2754C9 24.4846 10.7909 26.2754 13 26.2754H27.2113C29.4204 26.2754 31.2113 24.4846 31.2113 22.2754V13C31.2113 10.7909 29.4204 9 27.2113 9H13ZM26.9129 15.31C27.2282 14.9257 27.1723 14.3586 26.7881 14.0433C26.4038 13.728 25.8367 13.7839 25.5214 14.1682L22.4274 17.9389L18.9158 15.3218L18.2271 14.8085L17.6822 15.4725L14.0433 19.9072C13.728 20.2915 13.7839 20.8586 14.1682 21.1739C14.5524 21.4892 15.1195 21.4333 15.4348 21.049L18.5289 17.2783L22.0405 19.8954L22.7292 20.4087L23.274 19.7447L26.9129 15.31Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.1059 24.3714C20.5732 24.3714 20.9521 24.7502 20.9521 25.2175L20.9521 30.1534C20.9521 30.6207 20.5732 30.9995 20.1059 30.9995C19.6386 30.9995 19.2598 30.6207 19.2598 30.1534L19.2598 25.2175C19.2598 24.7502 19.6386 24.3714 20.1059 24.3714Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6533 30.1533C24.6533 30.6206 24.2745 30.9994 23.8072 30.9994H16.4034C15.9361 30.9994 15.5573 30.6206 15.5573 30.1533C15.5573 29.686 15.9361 29.3071 16.4034 29.3071H23.8072C24.2745 29.3071 24.6533 29.686 24.6533 30.1533Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 9C10.7909 9 9 10.7909 9 13V22.2754C9 24.4846 10.7909 26.2754 13 26.2754H27.2113C29.4204 26.2754 31.2113 24.4846 31.2113 22.2754V13C31.2113 10.7909 29.4204 9 27.2113 9H13ZM26.9129 15.31C27.2282 14.9257 27.1723 14.3586 26.7881 14.0433C26.4038 13.728 25.8367 13.7839 25.5214 14.1682L22.4274 17.9389L18.9158 15.3218L18.2271 14.8085L17.6822 15.4725L14.0433 19.9072C13.728 20.2915 13.7839 20.8586 14.1682 21.1739C14.5524 21.4892 15.1195 21.4333 15.4348 21.049L18.5289 17.2783L22.0405 19.8954L22.7292 20.4087L23.274 19.7447L26.9129 15.31Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.1059 24.3714C20.5732 24.3714 20.9521 24.7502 20.9521 25.2175L20.9521 30.1534C20.9521 30.6207 20.5732 30.9995 20.1059 30.9995C19.6386 30.9995 19.2598 30.6207 19.2598 30.1534L19.2598 25.2175C19.2598 24.7502 19.6386 24.3714 20.1059 24.3714Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6533 30.1533C24.6533 30.6206 24.2745 30.9994 23.8072 30.9994H16.4034C15.9361 30.9994 15.5573 30.6206 15.5573 30.1533C15.5573 29.686 15.9361 29.3071 16.4034 29.3071H23.8072C24.2745 29.3071 24.6533 29.686 24.6533 30.1533Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const PartiesIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19.9992" cy="13.9592" r="4.95919" fill={color} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0057 29.3375C10.1005 26.3715 11.3868 20.5713 19.9995 20.5713C28.6122 20.5713 29.8987 26.3714 29.9935 29.3374C30.025 30.3211 29.1932 31.0407 28.209 31.0407H11.7903C10.8061 31.0407 9.97433 30.3211 10.0057 29.3375ZM18.3463 27.0911L19.7307 21.3245C19.7955 21.0546 20.2033 21.0546 20.2681 21.3245L21.6524 27.0911L19.9994 28.8363L18.3463 27.0911Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19.9992" cy="13.9592" r="4.95919" fill={`${color}40`} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0057 29.3375C10.1005 26.3715 11.3868 20.5713 19.9995 20.5713C28.6122 20.5713 29.8987 26.3714 29.9935 29.3374C30.025 30.3211 29.1932 31.0407 28.209 31.0407H11.7903C10.8061 31.0407 9.97433 30.3211 10.0057 29.3375ZM18.3463 27.0911L19.7307 21.3245C19.7955 21.0546 20.2033 21.0546 20.2681 21.3245L21.6524 27.0911L19.9994 28.8363L18.3463 27.0911Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ItemIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.9724 9.52023C20.7489 8.82675 19.2511 8.82675 18.0276 9.52023L15 11.2363L12.0001 13.0002C10.7877 13.7131 10.0388 15.0102 10.0277 16.4165L10 19.8965L10.0277 23.3765C10.0388 24.7828 10.7877 26.08 12.0001 26.7928L15 28.5568L18.0276 30.2728C19.2511 30.9663 20.7489 30.9663 21.9724 30.2728L25 28.5568L27.9999 26.7928C29.2123 26.08 29.9612 24.7828 29.9723 23.3765L30 19.8965L29.9723 16.4165C29.9612 15.0102 29.2123 13.7131 27.9999 13.0002L25 11.2363L21.9724 9.52023ZM14.691 15.8788C14.3237 15.6686 13.8555 15.7959 13.6453 16.1632C13.4351 16.5305 13.5624 16.9987 13.9297 17.2089L18.8984 20.0528C19.2097 20.231 19.4017 20.5621 19.4017 20.9207V26.6014C19.4017 27.0246 19.7447 27.3676 20.168 27.3676C20.5912 27.3676 20.9342 27.0246 20.9342 26.6014V20.9011C20.9342 20.5485 21.12 20.2219 21.423 20.0416L26.1963 17.2025C26.5601 16.9861 26.6796 16.5159 26.4632 16.1522C26.2469 15.7884 25.7766 15.669 25.4129 15.8853L20.662 18.7111C20.3522 18.8954 19.967 18.8986 19.6541 18.7195L14.691 15.8788Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <>
      <div>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9724 9.52023C20.7489 8.82675 19.2511 8.82675 18.0276 9.52023L15 11.2363L12.0001 13.0002C10.7877 13.7131 10.0388 15.0102 10.0277 16.4165L10 19.8965L10.0277 23.3765C10.0388 24.7828 10.7877 26.08 12.0001 26.7928L15 28.5568L18.0276 30.2728C19.2511 30.9663 20.7489 30.9663 21.9724 30.2728L25 28.5568L27.9999 26.7928C29.2123 26.08 29.9612 24.7828 29.9723 23.3765L30 19.8965L29.9723 16.4165C29.9612 15.0102 29.2123 13.7131 27.9999 13.0002L25 11.2363L21.9724 9.52023ZM14.691 15.8788C14.3237 15.6686 13.8555 15.7959 13.6453 16.1632C13.4351 16.5305 13.5624 16.9987 13.9297 17.2089L18.8984 20.0528C19.2097 20.231 19.4017 20.5621 19.4017 20.9207V26.6014C19.4017 27.0246 19.7447 27.3676 20.168 27.3676C20.5912 27.3676 20.9342 27.0246 20.9342 26.6014V20.9011C20.9342 20.5485 21.12 20.2219 21.423 20.0416L26.1963 17.2025C26.5601 16.9861 26.6796 16.5159 26.4632 16.1522C26.2469 15.7884 25.7766 15.669 25.4129 15.8853L20.662 18.7111C20.3522 18.8954 19.967 18.8986 19.6541 18.7195L14.691 15.8788Z"
            fill={`${color}40`}
          />
        </svg>
      </div>
    </>
  );
};

export const SalesIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 17L12.7785 12.6712C12.6178 11.7068 11.7834 11 10.8057 11H10"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <circle cx="17" cy="30" r="1" fill={color} />
        <circle cx="27" cy="30" r="1" fill={color} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.541 13.9999H12L13.632 25.4241C13.8432 26.9021 15.1089 27.9999 16.6019 27.9999H27.3981C28.8911 27.9999 30.1568 26.9021 30.368 25.4241L31.5108 17.4241C31.769 15.6168 30.3666 13.9999 28.541 13.9999ZM22.8 15.9998C22.3582 15.9998 22 16.3579 22 16.7998C22 17.2416 22.3582 17.5998 22.8 17.5998H28.3C28.7418 17.5998 29.1 17.2416 29.1 16.7998C29.1 16.3579 28.7418 15.9998 28.3 15.9998H22.8Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 17L12.7785 12.6712C12.6178 11.7068 11.7834 11 10.8057 11H10"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <circle cx="17" cy="30" r="1" fill={`${color}40`} />
        <circle cx="27" cy="30" r="1" fill={`${color}40`} />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.541 13.9999H12L13.632 25.4241C13.8432 26.9021 15.1089 27.9999 16.6019 27.9999H27.3981C28.8911 27.9999 30.1568 26.9021 30.368 25.4241L31.5108 17.4241C31.769 15.6168 30.3666 13.9999 28.541 13.9999ZM22.8 15.9998C22.3582 15.9998 22 16.3579 22 16.7998C22 17.2416 22.3582 17.5998 22.8 17.5998H28.3C28.7418 17.5998 29.1 17.2416 29.1 16.7998C29.1 16.3579 28.7418 15.9998 28.3 15.9998H22.8Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const PurchaseIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6628 16.8916H16.7628V16.7916V11.1854C16.7628 10.1851 17.5737 9.37415 18.574 9.37415H21.9745C22.9748 9.37415 23.7857 10.1851 23.7857 11.1854V16.7916V16.8916H23.8857H25.1598H25.2598V16.7916V11.1854C25.2598 9.37091 23.7889 7.9 21.9745 7.9H18.574C16.7596 7.9 15.2887 9.37091 15.2887 11.1854V16.7916V16.8916H15.3887H16.6628Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6444 14.7528C12.0602 14.7528 10.7491 15.9846 10.6503 17.5657L10.006 27.8747C9.89802 29.6018 11.2697 31.0619 13.0001 31.0619H26.9997C28.7302 31.0619 30.1018 29.6018 29.9939 27.8747L29.3496 17.5657C29.2508 15.9846 27.9396 14.7528 26.3554 14.7528H13.6444ZM25.0931 21.1339C25.4152 20.8192 25.4212 20.3029 25.1065 19.9807C24.7918 19.6586 24.2755 19.6526 23.9534 19.9673L18.9874 24.8192L16.4994 22.3312C16.1809 22.0127 15.6646 22.0127 15.3461 22.3312C15.0277 22.6496 15.0277 23.1659 15.3461 23.4844L18.974 27.1123L25.0931 21.1339Z"
          fill={color}
        />
        <ellipse
          cx="16.1141"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={color}
        />
        <ellipse
          cx="24.5233"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6628 16.8916H16.7628V16.7916V11.1854C16.7628 10.1851 17.5737 9.37415 18.574 9.37415H21.9745C22.9748 9.37415 23.7857 10.1851 23.7857 11.1854V16.7916V16.8916H23.8857H25.1598H25.2598V16.7916V11.1854C25.2598 9.37091 23.7889 7.9 21.9745 7.9H18.574C16.7596 7.9 15.2887 9.37091 15.2887 11.1854V16.7916V16.8916H15.3887H16.6628Z"
          fill={`${color}40`}
          stroke={`${color}40`}
          stroke-width="0.2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6444 14.7528C12.0602 14.7528 10.7491 15.9846 10.6503 17.5657L10.006 27.8747C9.89802 29.6018 11.2697 31.0619 13.0001 31.0619H26.9997C28.7302 31.0619 30.1018 29.6018 29.9939 27.8747L29.3496 17.5657C29.2508 15.9846 27.9396 14.7528 26.3554 14.7528H13.6444ZM25.0931 21.1339C25.4152 20.8192 25.4212 20.3029 25.1065 19.9807C24.7918 19.6586 24.2755 19.6526 23.9534 19.9673L18.9874 24.8192L16.4994 22.3312C16.1809 22.0127 15.6646 22.0127 15.3461 22.3312C15.0277 22.6496 15.0277 23.1659 15.3461 23.4844L18.974 27.1123L25.0931 21.1339Z"
          fill={`${color}40`}
        />
        <ellipse
          cx="16.1141"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={`${color}40`}
        />
        <ellipse
          cx="24.5233"
          cy="16.3461"
          rx="0.701047"
          ry="0.701047"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ExpndIncIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-nan -nanL22 20C22 18.8954 22.8954 18 24 18H30V22H24C22.8954 22 22 21.1046 22 20L-nan -nanZ"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 10C11.7909 10 10 11.7909 10 14V26C10 28.2091 11.7909 30 14 30H26C28.2091 30 30 28.2091 30 26V23.5999H24C22.0118 23.5999 20.4 21.9881 20.4 19.9999C20.4 18.0117 22.0118 16.3999 24 16.3999H30V14C30 11.7909 28.2091 10 26 10H14ZM30 17.9999H24C22.8955 17.9999 22 18.8953 22 19.9999C22 21.1045 22.8955 21.9999 24 21.9999H30V17.9999ZM24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21ZM12 13C12 12.4477 12.4477 12 13 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H13C12.4477 14 12 13.5523 12 13Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-nan -nanL22 20C22 18.8954 22.8954 18 24 18H30V22H24C22.8954 22 22 21.1046 22 20L-nan -nanZ"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 10C11.7909 10 10 11.7909 10 14V26C10 28.2091 11.7909 30 14 30H26C28.2091 30 30 28.2091 30 26V23.5999H24C22.0118 23.5999 20.4 21.9881 20.4 19.9999C20.4 18.0117 22.0118 16.3999 24 16.3999H30V14C30 11.7909 28.2091 10 26 10H14ZM30 17.9999H24C22.8955 17.9999 22 18.8953 22 19.9999C22 21.1045 22.8955 21.9999 24 21.9999H30V17.9999ZM24 21C24.5523 21 25 20.5523 25 20C25 19.4477 24.5523 19 24 19C23.4477 19 23 19.4477 23 20C23 20.5523 23.4477 21 24 21ZM12 13C12 12.4477 12.4477 12 13 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H13C12.4477 14 12 13.5523 12 13Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const CashndBankIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="11.4141"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <rect
          x="17.8799"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <path
          d="M28.6562 26.019C29.8466 26.019 30.8115 26.984 30.8115 28.1744C30.8115 29.3647 29.8466 30.3297 28.6562 30.3297L11.4137 30.3297C10.2234 30.3297 9.25841 29.3647 9.25841 28.1744C9.25841 26.984 10.2234 26.019 11.4137 26.019L28.6562 26.019Z"
          fill={color}
        />
        <rect
          x="24.3457"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.7947 9.99911C21.1961 8.66696 18.8741 8.66696 17.2755 9.99911L9.38991 16.5705C8.61559 17.2157 9.07188 18.476 10.0798 18.476H29.9905C30.9984 18.476 31.4547 17.2157 30.6804 16.5705L22.7947 9.99911ZM20.2999 16.496C20.9094 16.496 21.4034 16.0019 21.4034 15.3925C21.4034 14.783 20.9094 14.289 20.2999 14.289C19.6904 14.289 19.1964 14.783 19.1964 15.3925C19.1964 16.0019 19.6904 16.496 20.2999 16.496Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="11.4141"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <rect
          x="17.8799"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <path
          d="M28.6562 26.019C29.8466 26.019 30.8115 26.984 30.8115 28.1744C30.8115 29.3647 29.8466 30.3297 28.6562 30.3297L11.4137 30.3297C10.2234 30.3297 9.25841 29.3647 9.25841 28.1744C9.25841 26.984 10.2234 26.019 11.4137 26.019L28.6562 26.019Z"
          fill={`${color}40`}
        />
        <rect
          x="24.3457"
          y="17.4237"
          width="4.31062"
          height="9.93162"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.7947 9.99911C21.1961 8.66696 18.8741 8.66696 17.2755 9.99911L9.38991 16.5705C8.61559 17.2157 9.07188 18.476 10.0798 18.476H29.9905C30.9984 18.476 31.4547 17.2157 30.6804 16.5705L22.7947 9.99911ZM20.2999 16.496C20.9094 16.496 21.4034 16.0019 21.4034 15.3925C21.4034 14.783 20.9094 14.289 20.2999 14.289C19.6904 14.289 19.1964 14.783 19.1964 15.3925C19.1964 16.0019 19.6904 16.496 20.2999 16.496Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const RegIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 13C11 10.7909 12.7909 9 15 9H25C27.2091 9 29 10.7909 29 13V20.4062C29 21.4503 28.5918 22.453 27.8626 23.2001L23.867 27.2939C23.1143 28.0651 22.0821 28.5 21.0044 28.5H15C12.7909 28.5 11 26.7091 11 24.5V13ZM14.2943 17.3752C14.2943 16.8818 14.6942 16.4818 15.1876 16.4818H24.9588C25.4522 16.4818 25.8522 16.8818 25.8522 17.3752C25.8522 17.8686 25.4522 18.2686 24.9588 18.2686H15.1876C14.6942 18.2686 14.2943 17.8686 14.2943 17.3752ZM15.3959 12.1421C14.9025 12.1421 14.5025 12.542 14.5025 13.0354C14.5025 13.5288 14.9025 13.9288 15.3959 13.9288H21.3959C21.8893 13.9288 22.2892 13.5288 22.2892 13.0354C22.2892 12.542 21.8893 12.1421 21.3959 12.1421H15.3959Z"
          fill={color}
        />
        <path
          d="M29.744 22.7158C30.1297 22.3205 30.7628 22.3127 31.1581 22.6983L31.6495 23.1777C32.0448 23.5634 32.0526 24.1965 31.6669 24.5918L25.2021 31.218L22.9615 31.591L23.2792 29.3419L29.744 22.7158Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 13C11 10.7909 12.7909 9 15 9H25C27.2091 9 29 10.7909 29 13V20.4062C29 21.4503 28.5918 22.453 27.8626 23.2001L23.867 27.2939C23.1143 28.0651 22.0821 28.5 21.0044 28.5H15C12.7909 28.5 11 26.7091 11 24.5V13ZM14.2943 17.3752C14.2943 16.8818 14.6942 16.4818 15.1876 16.4818H24.9588C25.4522 16.4818 25.8522 16.8818 25.8522 17.3752C25.8522 17.8686 25.4522 18.2686 24.9588 18.2686H15.1876C14.6942 18.2686 14.2943 17.8686 14.2943 17.3752ZM15.3959 12.1421C14.9025 12.1421 14.5025 12.542 14.5025 13.0354C14.5025 13.5288 14.9025 13.9288 15.3959 13.9288H21.3959C21.8893 13.9288 22.2892 13.5288 22.2892 13.0354C22.2892 12.542 21.8893 12.1421 21.3959 12.1421H15.3959Z"
          fill={`${color}40`}
        />
        <path
          d="M29.744 22.7158C30.1297 22.3205 30.7628 22.3127 31.1581 22.6983L31.6495 23.1777C32.0448 23.5634 32.0526 24.1965 31.6669 24.5918L25.2021 31.218L22.9615 31.591L23.2792 29.3419L29.744 22.7158Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const RepIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={color}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={color}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={`${color}40`}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={`${color}40`}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export const MasterIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={color}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={color}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5 9.26697C11.567 9.26697 10 10.834 10 12.767V26.0488C10 28.2387 11.761 30.0215 13.9508 30.0485L25.9508 30.196C28.179 30.2234 30 28.4247 30 26.1963V12.267C30 10.6101 28.6569 9.26697 27 9.26697H26.45C26.3395 9.26697 26.25 9.35651 26.25 9.46697C26.25 10.4611 25.4441 11.267 24.45 11.267H16.175C15.1809 11.267 14.375 10.4611 14.375 9.46697C14.375 9.35651 14.2855 9.26697 14.175 9.26697H13.5ZM26.7325 16.8419C27.1607 16.4374 27.18 15.7623 26.7755 15.3341C26.371 14.9058 25.6959 14.8865 25.2677 15.291L20.9804 19.34L19.3861 17.8343C18.8723 17.349 18.069 17.349 17.5551 17.8343L14.601 20.6243C14.1727 21.0288 14.1534 21.7039 14.5579 22.1322C14.9624 22.5605 15.6375 22.5798 16.0658 22.1753L18.4706 19.904L20.0649 21.4098C20.5788 21.8951 21.3821 21.8951 21.8959 21.4098L26.7325 16.8419Z"
          fill={`${color}40`}
        />
        <path
          d="M16.667 9H24.0003"
          stroke={`${color}40`}
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export const SettingIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0191 9C21.4688 9 21.8333 9.36454 21.8333 9.81422C21.8333 11.6866 24.1481 12.5658 25.3912 11.1656C25.6897 10.8293 26.2043 10.7987 26.5406 11.0972L27.9426 12.3418C28.3464 12.7003 28.3831 13.3183 28.0246 13.7221L27.6897 14.0994C26.29 15.6762 27.4093 18.1667 29.5178 18.1667H30.0222C30.5622 18.1667 31 18.6044 31 19.1444V20.8989C31 21.415 30.5817 21.8333 30.0656 21.8333C27.9845 21.8333 26.9423 24.3495 28.4139 25.8211C28.7788 26.186 28.7788 26.7776 28.4139 27.1425L27.1426 28.4138C26.7777 28.7787 26.1861 28.7787 25.8212 28.4138C24.3496 26.9422 21.8333 27.9844 21.8333 30.0656C21.8333 30.5817 21.415 31 20.8989 31H18.9809C18.5312 31 18.1667 30.6355 18.1667 30.1858C18.1667 28.3134 15.8519 27.4342 14.6088 28.8344C14.3103 29.1707 13.7957 29.2013 13.4594 28.9027L12.0575 27.6582C11.6536 27.2997 11.6169 26.6817 11.9754 26.2778L12.3102 25.9006C13.71 24.3238 12.5906 21.8333 10.4822 21.8333H9.97778C9.43777 21.8333 9 21.3956 9 20.8556V19.1011C9 18.585 9.41835 18.1667 9.93441 18.1667C12.0155 18.1667 13.0578 15.6505 11.5862 14.1789C11.2213 13.814 11.2213 13.2224 11.5862 12.8575L12.8576 11.5862C13.2225 11.2213 13.8141 11.2213 14.179 11.5862C15.6505 13.0577 18.1667 12.0155 18.1667 9.93439C18.1667 9.41834 18.585 9 19.1011 9H21.0191ZM20 23.3C21.8225 23.3 23.3 21.8225 23.3 20C23.3 18.1775 21.8225 16.7 20 16.7C18.1775 16.7 16.7 18.1775 16.7 20C16.7 21.8225 18.1775 23.3 20 23.3Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0191 9C21.4688 9 21.8333 9.36454 21.8333 9.81422C21.8333 11.6866 24.1481 12.5658 25.3912 11.1656C25.6897 10.8293 26.2043 10.7987 26.5406 11.0972L27.9426 12.3418C28.3464 12.7003 28.3831 13.3183 28.0246 13.7221L27.6897 14.0994C26.29 15.6762 27.4093 18.1667 29.5178 18.1667H30.0222C30.5622 18.1667 31 18.6044 31 19.1444V20.8989C31 21.415 30.5817 21.8333 30.0656 21.8333C27.9845 21.8333 26.9423 24.3495 28.4139 25.8211C28.7788 26.186 28.7788 26.7776 28.4139 27.1425L27.1426 28.4138C26.7777 28.7787 26.1861 28.7787 25.8212 28.4138C24.3496 26.9422 21.8333 27.9844 21.8333 30.0656C21.8333 30.5817 21.415 31 20.8989 31H18.9809C18.5312 31 18.1667 30.6355 18.1667 30.1858C18.1667 28.3134 15.8519 27.4342 14.6088 28.8344C14.3103 29.1707 13.7957 29.2013 13.4594 28.9027L12.0575 27.6582C11.6536 27.2997 11.6169 26.6817 11.9754 26.2778L12.3102 25.9006C13.71 24.3238 12.5906 21.8333 10.4822 21.8333H9.97778C9.43777 21.8333 9 21.3956 9 20.8556V19.1011C9 18.585 9.41835 18.1667 9.93441 18.1667C12.0155 18.1667 13.0578 15.6505 11.5862 14.1789C11.2213 13.814 11.2213 13.2224 11.5862 12.8575L12.8576 11.5862C13.2225 11.2213 13.8141 11.2213 14.179 11.5862C15.6505 13.0577 18.1667 12.0155 18.1667 9.93439C18.1667 9.41834 18.585 9 19.1011 9H21.0191ZM20 23.3C21.8225 23.3 23.3 21.8225 23.3 20C23.3 18.1775 21.8225 16.7 20 16.7C18.1775 16.7 16.7 18.1775 16.7 20C16.7 21.8225 18.1775 23.3 20 23.3Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const AllClientIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="22.3347"
          cy="12.9278"
          rx="2.93141"
          ry="2.93141"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M24.1167 10.9137C23.8336 12.3295 21.2852 14.0284 19.5863 13.394C18.7769 11.992 19.3068 11.1391 20.7089 10.3296C22.111 9.5201 22.9841 9.78115 24.1167 10.9137Z"
          fill={color}
        />
        <path
          d="M25.7765 21.109C26.6217 21.109 27.3273 20.3855 26.9187 19.6456C26.6625 19.1817 26.2869 18.7601 25.8135 18.405C25.34 18.0499 24.7779 17.7682 24.1593 17.5761C23.5407 17.3839 22.8777 17.285 22.2081 17.285C21.5385 17.285 20.8755 17.3839 20.2569 17.5761C19.6383 17.7682 19.0762 18.0499 18.6028 18.405C18.1293 18.7601 17.7537 19.1817 17.4975 19.6456C17.0889 20.3855 17.7945 21.109 18.6397 21.109H25.7765Z"
          fill={color}
        />
        <rect
          x="5"
          y="19.8343"
          width="3.14461"
          height="9.56015"
          rx="1"
          fill={color}
        />
        <path
          d="M8.82422 21.0779C8.82422 21.0779 10.0989 19.8343 12.0109 19.8343C13.3314 19.8343 14.4998 20.4867 15.5163 21.0543C15.9717 21.3085 16.3966 21.5458 16.791 21.6997C17.8032 22.0947 20.9585 23.0385 23.3853 23.5662C24.0816 23.7176 24.6556 24.1972 24.9198 24.8239C25.0328 25.092 24.9656 25.4062 24.718 25.559C24.4662 25.7142 24.0714 25.8634 23.4853 25.948C22.3117 26.1175 20.4195 26.0213 17.5088 25.2619C17.3385 25.2175 17.1644 25.3196 17.12 25.4898C17.0755 25.6601 17.1776 25.8342 17.3479 25.8786C20.3007 26.6489 22.2856 26.7652 23.5764 26.5788C24.2225 26.4855 24.7068 26.3146 25.0525 26.1014C25.0825 26.0829 25.1298 26.0518 25.1913 26.0101C26.8589 24.8789 28.4843 23.6777 30.208 22.6339L33.5576 20.6056C34.0248 20.3227 34.6106 20.3236 35.0768 20.6079C35.9456 21.1376 36.0215 22.3705 35.2243 23.0028L26.8027 29.6821C26.0266 30.2976 25.1526 30.7783 24.2173 31.1042L23.06 31.5074C21.0708 32.2004 18.8994 32.1604 16.9371 31.3946L8.82422 28.2286V21.0779Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="22.3347"
          cy="12.9278"
          rx="2.93141"
          ry="2.93141"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M24.1167 10.9137C23.8336 12.3295 21.2852 14.0284 19.5863 13.394C18.7769 11.992 19.3068 11.1391 20.7089 10.3296C22.111 9.5201 22.9841 9.78115 24.1167 10.9137Z"
          fill={`${color}40`}
        />
        <path
          d="M25.7765 21.109C26.6217 21.109 27.3273 20.3855 26.9187 19.6456C26.6625 19.1817 26.2869 18.7601 25.8135 18.405C25.34 18.0499 24.7779 17.7682 24.1593 17.5761C23.5407 17.3839 22.8777 17.285 22.2081 17.285C21.5385 17.285 20.8755 17.3839 20.2569 17.5761C19.6383 17.7682 19.0762 18.0499 18.6028 18.405C18.1293 18.7601 17.7537 19.1817 17.4975 19.6456C17.0889 20.3855 17.7945 21.109 18.6397 21.109H25.7765Z"
          fill={`${color}40`}
        />
        <rect
          x="5"
          y="19.8343"
          width="3.14461"
          height="9.56015"
          rx="1"
          fill={`${color}40`}
        />
        <path
          d="M8.82422 21.0779C8.82422 21.0779 10.0989 19.8343 12.0109 19.8343C13.3314 19.8343 14.4998 20.4867 15.5163 21.0543C15.9717 21.3085 16.3966 21.5458 16.791 21.6997C17.8032 22.0947 20.9585 23.0385 23.3853 23.5662C24.0816 23.7176 24.6556 24.1972 24.9198 24.8239C25.0328 25.092 24.9656 25.4062 24.718 25.559C24.4662 25.7142 24.0714 25.8634 23.4853 25.948C22.3117 26.1175 20.4195 26.0213 17.5088 25.2619C17.3385 25.2175 17.1644 25.3196 17.12 25.4898C17.0755 25.6601 17.1776 25.8342 17.3479 25.8786C20.3007 26.6489 22.2856 26.7652 23.5764 26.5788C24.2225 26.4855 24.7068 26.3146 25.0525 26.1014C25.0825 26.0829 25.1298 26.0518 25.1913 26.0101C26.8589 24.8789 28.4843 23.6777 30.208 22.6339L33.5576 20.6056C34.0248 20.3227 34.6106 20.3236 35.0768 20.6079C35.9456 21.1376 36.0215 22.3705 35.2243 23.0028L26.8027 29.6821C26.0266 30.2976 25.1526 30.7783 24.2173 31.1042L23.06 31.5074C21.0708 32.2004 18.8994 32.1604 16.9371 31.3946L8.82422 28.2286V21.0779Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const UserIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="20.199"
          cy="15.163"
          rx="4.59941"
          ry="4.59942"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M22.995 12.0022C22.5507 14.2235 18.5524 16.8891 15.8868 15.8939C14.6167 13.694 15.4482 12.3558 17.6481 11.0857C19.848 9.8156 21.2179 10.2252 22.995 12.0022Z"
          fill={color}
        />
        <path
          d="M26.3977 31C28.0545 31 29.4436 29.6224 28.9128 28.0529C28.8475 27.8597 28.7757 27.6686 28.6974 27.4797C28.2352 26.3637 27.5576 25.3496 26.7034 24.4954C25.8492 23.6412 24.8351 22.9637 23.7191 22.5014C22.603 22.0391 21.4068 21.8011 20.1988 21.8011C18.9908 21.8011 17.7946 22.0391 16.6786 22.5014C15.5625 22.9637 14.5485 23.6412 13.6943 24.4954C12.8401 25.3496 12.1625 26.3637 11.7002 27.4797C11.622 27.6686 11.5502 27.8597 11.4849 28.0529C10.9541 29.6224 12.3431 31 14 31H26.3977Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="20.199"
          cy="15.163"
          rx="4.59941"
          ry="4.59942"
          stroke={`${color}40`}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M22.995 12.0022C22.5507 14.2235 18.5524 16.8891 15.8868 15.8939C14.6167 13.694 15.4482 12.3558 17.6481 11.0857C19.848 9.8156 21.2179 10.2252 22.995 12.0022Z"
          fill={`${color}40`}
        />
        <path
          d="M26.3977 31C28.0545 31 29.4436 29.6224 28.9128 28.0529C28.8475 27.8597 28.7757 27.6686 28.6974 27.4797C28.2352 26.3637 27.5576 25.3496 26.7034 24.4954C25.8492 23.6412 24.8351 22.9637 23.7191 22.5014C22.603 22.0391 21.4068 21.8011 20.1988 21.8011C18.9908 21.8011 17.7946 22.0391 16.6786 22.5014C15.5625 22.9637 14.5485 23.6412 13.6943 24.4954C12.8401 25.3496 12.1625 26.3637 11.7002 27.4797C11.622 27.6686 11.5502 27.8597 11.4849 28.0529C10.9541 29.6224 12.3431 31 14 31H26.3977Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const MenuIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        fill="white"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M12 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H12V4Z"
        fill={color}
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 7H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 10H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 13H9"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  ) : (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M12 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H12V4Z"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 7H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 10H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M7 13H9"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const DraftIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15.8717C9 15.2603 9.4956 14.7647 10.107 14.7647C10.7183 14.7647 11.2139 15.2603 11.2139 15.8717V23.4561C11.2139 26.3998 13.6002 28.7861 16.5439 28.7861H22.5629C22.8565 28.7861 23.138 28.9027 23.3456 29.1103C24.043 29.8077 23.5491 31 22.5629 31H16C12.134 31 9 27.866 9 24V15.8717Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2393 8C15.0301 8 13.2393 9.79086 13.2393 12V22.7608C13.2393 24.9699 15.0301 26.7608 17.2393 26.7608H26.5569C28.766 26.7608 30.5569 24.9699 30.5569 22.7608V12C30.5569 9.79086 28.766 8 26.5569 8H17.2393ZM25.6697 12.4102C25.0992 11.8536 24.1855 11.8649 23.6289 12.4353L16.3668 19.8787L16 22.4753L18.5868 22.0446L25.8489 14.6013C26.4055 14.0308 26.3943 13.1171 25.8238 12.5605L25.6697 12.4102ZM23.8823 22.2516C23.8823 22.9988 23.2766 23.6045 22.5294 23.6045C21.7821 23.6045 21.1764 22.9988 21.1764 22.2516C21.1764 21.5044 21.7821 20.8987 22.5294 20.8987C23.2766 20.8987 23.8823 21.5044 23.8823 22.2516ZM26.8588 23.6045C27.606 23.6045 28.2117 22.9988 28.2117 22.2516C28.2117 21.5044 27.606 20.8987 26.8588 20.8987C26.1116 20.8987 25.5058 21.5044 25.5058 22.2516C25.5058 22.9988 26.1116 23.6045 26.8588 23.6045Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15.8717C9 15.2603 9.4956 14.7647 10.107 14.7647C10.7183 14.7647 11.2139 15.2603 11.2139 15.8717V23.4561C11.2139 26.3998 13.6002 28.7861 16.5439 28.7861H22.5629C22.8565 28.7861 23.138 28.9027 23.3456 29.1103C24.043 29.8077 23.5491 31 22.5629 31H16C12.134 31 9 27.866 9 24V15.8717Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2393 8C15.0301 8 13.2393 9.79086 13.2393 12V22.7608C13.2393 24.9699 15.0301 26.7608 17.2393 26.7608H26.5569C28.766 26.7608 30.5569 24.9699 30.5569 22.7608V12C30.5569 9.79086 28.766 8 26.5569 8H17.2393ZM25.6697 12.4102C25.0992 11.8536 24.1855 11.8649 23.6289 12.4353L16.3668 19.8787L16 22.4753L18.5868 22.0446L25.8489 14.6013C26.4055 14.0308 26.3943 13.1171 25.8238 12.5605L25.6697 12.4102ZM23.8823 22.2516C23.8823 22.9988 23.2766 23.6045 22.5294 23.6045C21.7821 23.6045 21.1764 22.9988 21.1764 22.2516C21.1764 21.5044 21.7821 20.8987 22.5294 20.8987C23.2766 20.8987 23.8823 21.5044 23.8823 22.2516ZM26.8588 23.6045C27.606 23.6045 28.2117 22.9988 28.2117 22.2516C28.2117 21.5044 27.606 20.8987 26.8588 20.8987C26.1116 20.8987 25.5058 21.5044 25.5058 22.2516C25.5058 22.9988 26.1116 23.6045 26.8588 23.6045Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const ReportIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 9C11.7909 9 10 10.7909 10 13V28C10 30.2091 11.7909 32 14 32H26C28.2091 32 30 30.2091 30 28V13C30 10.7909 28.2091 9 26 9H14ZM21.4712 18.5834C21.97 17.8742 22.2362 17.0404 22.2362 16.1875H17.6968V11.875C16.7989 11.875 15.9213 12.1279 15.1748 12.6018C14.4282 13.0757 13.8464 13.7492 13.5028 14.5372C13.1592 15.3252 13.0693 16.1923 13.2445 17.0288C13.4197 17.8654 13.852 18.6338 14.4869 19.2369C15.1217 19.84 15.9306 20.2507 16.8111 20.4171C17.6917 20.5835 18.6045 20.4981 19.4339 20.1717C20.2634 19.8453 20.9724 19.2926 21.4712 18.5834ZM13.1573 23.8931C13.1573 24.3865 13.5783 24.7865 14.0977 24.7865H24.3831C24.9025 24.7865 25.3235 24.3865 25.3235 23.8931C25.3235 23.3997 24.9025 22.9998 24.3831 22.9998H14.0977C13.5783 22.9998 13.1573 23.3997 13.1573 23.8931ZM14.3166 29.1262C13.7973 29.1262 13.3762 28.7262 13.3762 28.2329C13.3762 27.7395 13.7973 27.3395 14.3166 27.3395H20.6324C21.1518 27.3395 21.5728 27.7395 21.5728 28.2329C21.5728 28.7262 21.1518 29.1262 20.6324 29.1262H14.3166Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 9C11.7909 9 10 10.7909 10 13V28C10 30.2091 11.7909 32 14 32H26C28.2091 32 30 30.2091 30 28V13C30 10.7909 28.2091 9 26 9H14ZM21.4712 18.5834C21.97 17.8742 22.2362 17.0404 22.2362 16.1875H17.6968V11.875C16.7989 11.875 15.9213 12.1279 15.1748 12.6018C14.4282 13.0757 13.8464 13.7492 13.5028 14.5372C13.1592 15.3252 13.0693 16.1923 13.2445 17.0288C13.4197 17.8654 13.852 18.6338 14.4869 19.2369C15.1217 19.84 15.9306 20.2507 16.8111 20.4171C17.6917 20.5835 18.6045 20.4981 19.4339 20.1717C20.2634 19.8453 20.9724 19.2926 21.4712 18.5834ZM13.1573 23.8931C13.1573 24.3865 13.5783 24.7865 14.0977 24.7865H24.3831C24.9025 24.7865 25.3235 24.3865 25.3235 23.8931C25.3235 23.3997 24.9025 22.9998 24.3831 22.9998H14.0977C13.5783 22.9998 13.1573 23.3997 13.1573 23.8931ZM14.3166 29.1262C13.7973 29.1262 13.3762 28.7262 13.3762 28.2329C13.3762 27.7395 13.7973 27.3395 14.3166 27.3395H20.6324C21.1518 27.3395 21.5728 27.7395 21.5728 28.2329C21.5728 28.7262 21.1518 29.1262 20.6324 29.1262H14.3166Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const AssetIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3843 10.3716C14.5153 10.1418 14.7595 10 15.024 10H21.732C22.2973 10 22.6519 10.6105 22.3717 11.1015C22.2407 11.3313 21.9965 11.4731 21.732 11.4731H19.4201C19.8235 11.9003 20.126 12.4012 20.3025 12.9462H21.732C22.2973 12.9462 22.6519 13.5567 22.3717 14.0477C22.2407 14.2775 21.9965 14.4193 21.732 14.4193H20.479C20.3745 15.3375 19.9193 16.1979 19.1872 16.861C18.455 17.5241 17.4888 17.951 16.4451 18.0726V18.1021H15.8568L20.3025 22.7775L18.3371 22.9455L14.044 18.4067C13.859 18.2111 13.7559 17.952 13.7559 17.6827C13.7559 17.1007 14.2276 16.629 14.8096 16.629H15.8568C17.3359 16.629 18.5629 15.6714 18.7646 14.4193H15.024C14.4587 14.4193 14.1041 13.8088 14.3843 13.3178C14.5153 13.088 14.7595 12.9462 15.024 12.9462H18.5125C18.0418 12.0771 17.0334 11.4731 15.8568 11.4731H15.024C14.4587 11.4731 14.1041 10.8626 14.3843 10.3716Z"
          fill={color}
        />
        <path
          d="M10 22.9L10 28.8998"
          stroke="#004B8B"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11.5 28.0005V25V23.0405C11.5 22.6048 11.7953 22.2245 12.2174 22.1166L13.3595 21.8247C14.4371 21.5492 15.5752 21.6346 16.5996 22.0678C17.913 22.6232 19.3992 22.6016 20.6959 22.0084L21.4974 21.6417C21.8115 21.498 22.1825 21.5757 22.4125 21.8333L22.522 21.9559C22.7171 22.1745 22.8213 22.4765 22.6808 22.7335C22.2 23.6133 20.644 24.5424 18.5 25.4C20.3286 26.3143 22.8466 25.1293 28.6232 23.5601C29.5085 23.3197 30.3855 23.9595 30.4395 24.8753C30.4758 25.4901 30.1226 26.0618 29.5565 26.3044L23.0939 29.0741C21.0653 29.9435 18.8475 30.278 16.6526 30.0456L12.9912 29.6579C12.1434 29.5681 11.5 28.8531 11.5 28.0005Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3843 10.3716C14.5153 10.1418 14.7595 10 15.024 10H21.732C22.2973 10 22.6519 10.6105 22.3717 11.1015C22.2407 11.3313 21.9965 11.4731 21.732 11.4731H19.4201C19.8235 11.9003 20.126 12.4012 20.3025 12.9462H21.732C22.2973 12.9462 22.6519 13.5567 22.3717 14.0477C22.2407 14.2775 21.9965 14.4193 21.732 14.4193H20.479C20.3745 15.3375 19.9193 16.1979 19.1872 16.861C18.455 17.5241 17.4888 17.951 16.4451 18.0726V18.1021H15.8568L20.3025 22.7775L18.3371 22.9455L14.044 18.4067C13.859 18.2111 13.7559 17.952 13.7559 17.6827C13.7559 17.1007 14.2276 16.629 14.8096 16.629H15.8568C17.3359 16.629 18.5629 15.6714 18.7646 14.4193H15.024C14.4587 14.4193 14.1041 13.8088 14.3843 13.3178C14.5153 13.088 14.7595 12.9462 15.024 12.9462H18.5125C18.0418 12.0771 17.0334 11.4731 15.8568 11.4731H15.024C14.4587 11.4731 14.1041 10.8626 14.3843 10.3716Z"
          fill={`${color}40`}
        />
        <path
          d="M10 22.9L10 28.8998"
          stroke="#AAC9E3"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11.5 28.0005V25V23.0405C11.5 22.6048 11.7953 22.2245 12.2174 22.1166L13.3595 21.8247C14.4371 21.5492 15.5752 21.6346 16.5996 22.0678C17.913 22.6232 19.3992 22.6016 20.6959 22.0084L21.4974 21.6417C21.8115 21.498 22.1825 21.5757 22.4125 21.8333L22.522 21.9559C22.7171 22.1745 22.8213 22.4765 22.6808 22.7335C22.2 23.6133 20.644 24.5424 18.5 25.4C20.3286 26.3143 22.8466 25.1293 28.6232 23.5601C29.5085 23.3197 30.3855 23.9595 30.4395 24.8753C30.4758 25.4901 30.1226 26.0618 29.5565 26.3044L23.0939 29.0741C21.0653 29.9435 18.8475 30.278 16.6526 30.0456L12.9912 29.6579C12.1434 29.5681 11.5 28.8531 11.5 28.0005Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};

export const JournalIcon: React.FC<IconProps> = ({
  active = false,
  color = "#004B8B",
}) => {
  return active ? (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 13.5143C10 13.0409 10.3838 12.6571 10.8572 12.6571H11.4806V14.3716H10.8572C10.3838 14.3716 10 13.9878 10 13.5143Z"
          fill={color}
        />
        <path
          d="M10 18.0609C10 17.5874 10.3838 17.2036 10.8572 17.2036H11.4806V18.9181H10.8572C10.3838 18.9181 10 18.5343 10 18.0609Z"
          fill={color}
        />
        <path
          d="M10 22.7062C10 22.2328 10.3838 21.849 10.8572 21.849H11.4806V23.5635H10.8572C10.3838 23.5635 10 23.1797 10 22.7062Z"
          fill={color}
        />
        <path
          d="M27.6628 22.3666C27.9844 22.0117 28.5378 21.979 28.8989 22.2938L29.3463 22.6838C29.7074 22.9985 29.7394 23.5414 29.4178 23.8964L24.0452 29.8265L22.1043 30.2353L22.2902 28.2967L27.6628 22.3666Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9488 9.00012C13.0328 9.00012 11.4795 10.5534 11.4795 12.4694V24.3902C11.4795 26.3062 13.0328 27.8595 14.9488 27.8595H20.1299C21.1256 27.8595 22.0733 27.4317 22.7318 26.685L26.3434 22.5901C26.9024 21.9563 27.2108 21.1403 27.2108 20.2953V12.4694C27.2108 10.5534 25.6576 9.00012 23.7415 9.00012H14.9488ZM13.2285 14.3715C13.7111 14.3715 14.1024 13.9877 14.1024 13.5143C14.1024 13.0408 13.7111 12.657 13.2285 12.657C12.7458 12.657 12.3545 13.0408 12.3545 13.5143C12.3545 13.9877 12.7458 14.3715 13.2285 14.3715ZM14.1024 22.7062C14.1024 23.1796 13.7111 23.5634 13.2285 23.5634C12.7458 23.5634 12.3545 23.1796 12.3545 22.7062C12.3545 22.2328 12.7458 21.849 13.2285 21.849C13.7111 21.849 14.1024 22.2328 14.1024 22.7062ZM13.2285 18.9181C13.7111 18.9181 14.1024 18.5343 14.1024 18.0609C14.1024 17.5875 13.7111 17.2037 13.2285 17.2037C12.7458 17.2037 12.3545 17.5875 12.3545 18.0609C12.3545 18.5343 12.7458 18.9181 13.2285 18.9181Z"
          fill={color}
        />
      </svg>
    </div>
  ) : (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 13.5143C10 13.0409 10.3838 12.6571 10.8572 12.6571H11.4806V14.3716H10.8572C10.3838 14.3716 10 13.9878 10 13.5143Z"
          fill={`${color}40`}
        />
        <path
          d="M10 18.0609C10 17.5874 10.3838 17.2036 10.8572 17.2036H11.4806V18.9181H10.8572C10.3838 18.9181 10 18.5343 10 18.0609Z"
          fill={`${color}40`}
        />
        <path
          d="M10 22.7062C10 22.2328 10.3838 21.849 10.8572 21.849H11.4806V23.5635H10.8572C10.3838 23.5635 10 23.1797 10 22.7062Z"
          fill={`${color}40`}
        />
        <path
          d="M27.6628 22.3666C27.9844 22.0117 28.5378 21.979 28.8989 22.2938L29.3463 22.6838C29.7074 22.9985 29.7394 23.5414 29.4178 23.8964L24.0452 29.8265L22.1043 30.2353L22.2902 28.2967L27.6628 22.3666Z"
          fill={`${color}40`}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9488 9.00012C13.0328 9.00012 11.4795 10.5534 11.4795 12.4694V24.3902C11.4795 26.3062 13.0328 27.8595 14.9488 27.8595H20.1299C21.1256 27.8595 22.0733 27.4317 22.7318 26.685L26.3434 22.5901C26.9024 21.9563 27.2108 21.1403 27.2108 20.2953V12.4694C27.2108 10.5534 25.6576 9.00012 23.7415 9.00012H14.9488ZM13.2285 14.3715C13.7111 14.3715 14.1024 13.9877 14.1024 13.5143C14.1024 13.0408 13.7111 12.657 13.2285 12.657C12.7458 12.657 12.3545 13.0408 12.3545 13.5143C12.3545 13.9877 12.7458 14.3715 13.2285 14.3715ZM14.1024 22.7062C14.1024 23.1796 13.7111 23.5634 13.2285 23.5634C12.7458 23.5634 12.3545 23.1796 12.3545 22.7062C12.3545 22.2328 12.7458 21.849 13.2285 21.849C13.7111 21.849 14.1024 22.2328 14.1024 22.7062ZM13.2285 18.9181C13.7111 18.9181 14.1024 18.5343 14.1024 18.0609C14.1024 17.5875 13.7111 17.2037 13.2285 17.2037C12.7458 17.2037 12.3545 17.5875 12.3545 18.0609C12.3545 18.5343 12.7458 18.9181 13.2285 18.9181Z"
          fill={`${color}40`}
        />
      </svg>
    </div>
  );
};
// Add remaining icons similarly from 5 to 10
